<div class="guest-wizard">

  <!-- ── Added guests chips ── -->
  @if (addedGuests().length > 0) {
    <div class="guest-wizard__added">
      <span class="guest-wizard__counter">{{ addedGuests().length }} guest{{ addedGuests().length === 1 ? '' : 's' }} added</span>
      <div class="guest-wizard__chips">
        @for (guest of addedGuests(); track guest.email) {
          <span class="guest-wizard__chip">
            <span class="guest-wizard__chip-label">{{ guest.name || guest.email }}</span>
            <button type="button" class="guest-wizard__chip-remove"
              (click)="onRemoveGuest(guest.email)" aria-label="Remove guest">
              <i class="pi pi-times" aria-hidden="true"></i>
            </button>
          </span>
        }
      </div>
    </div>
  }

  <!-- ── Step: Ask Yes/No (booking mode only) ── -->
  @if (step() === 'ask') {
    <p class="guest-wizard__question">
      {{ addedGuests().length === 0 ? 'Would you like to add additional guests?' : 'Add another guest?' }}
    </p>
    <div class="guest-wizard__options">
      <button type="button" class="guest-wizard__btn guest-wizard__btn--yes" [disabled]="disabled" (click)="onYes()">
        <i class="pi pi-check" aria-hidden="true"></i> Yes
      </button>
      <button type="button" class="guest-wizard__btn guest-wizard__btn--no" [disabled]="disabled" (click)="onNo()">
        {{ addedGuests().length > 0 ? 'Done' : 'No, skip' }}
      </button>
    </div>
  }

  <!-- ── Step: Choose method ── -->
  @if (step() === 'choose-method') {
    <p class="guest-wizard__question">How would you like to add a guest?</p>
    <div class="guest-wizard__options">
      @if (hasContacts) {
        <button type="button" class="guest-wizard__btn guest-wizard__btn--method" [disabled]="disabled" (click)="onChooseContact()">
          <i class="pi pi-users" aria-hidden="true"></i> Select from contacts
        </button>
      }
      <button type="button" class="guest-wizard__btn guest-wizard__btn--method" [disabled]="disabled" (click)="onChooseEmail()">
        <i class="pi pi-envelope" aria-hidden="true"></i> Enter email
      </button>
    </div>
    <div class="guest-wizard__nav">
      @if (mode === 'booking') {
        <button type="button" class="guest-wizard__back" [disabled]="disabled" (click)="onBackToAsk()">
          <i class="pi pi-arrow-left" aria-hidden="true"></i> Back
        </button>
      } @else {
        <button type="button" class="guest-wizard__back" [disabled]="disabled" (click)="onCancel()">
          <i class="pi pi-times" aria-hidden="true"></i> Cancel
        </button>
      }
      @if (addedGuests().length > 0) {
        <button type="button" class="guest-wizard__btn guest-wizard__btn--no" [disabled]="disabled" (click)="onNo()">
          <i class="pi pi-check-circle" aria-hidden="true"></i> Proceed with selected guests
        </button>
      }
    </div>
  }

  <!-- ── Step: Pick contact ── -->
  @if (step() === 'pick-contact') {
    <div class="guest-wizard__contact-picker">
      <div class="guest-wizard__search-wrap">
        <i class="pi pi-search guest-wizard__search-icon" aria-hidden="true"></i>
        <input type="text" class="guest-wizard__search"
          placeholder="Search by name, email, or title…"
          [value]="contactSearch()"
          (input)="onSearchInput($event)"
          [disabled]="disabled"
          aria-label="Search contacts" />
      </div>
      <div class="guest-wizard__contact-grid">
        @for (contact of filteredContacts; track contact.id) {
          <button type="button" class="contact-card"
            [disabled]="disabled"
            (click)="onContactPick(contact)"
            [attr.aria-label]="'Select ' + contact.first_name + ' ' + contact.last_name">
            <span class="contact-card__name">{{ contact.first_name }} {{ contact.last_name }}</span>
            @if (contact.title) { <span class="contact-card__title">{{ contact.title }}</span> }
            @if (contact.email) { <span class="contact-card__email">{{ contact.email }}</span> }
          </button>
        }
        @if (filteredContacts.length === 0) {
          <p class="guest-wizard__no-results">No contacts match your search.</p>
        }
      </div>
      <div class="guest-wizard__nav">
        <button type="button" class="guest-wizard__back" [disabled]="disabled" (click)="onBackToMethod()">
          <i class="pi pi-arrow-left" aria-hidden="true"></i> Back
        </button>
        @if (addedGuests().length > 0) {
          <button type="button" class="guest-wizard__btn guest-wizard__btn--no" [disabled]="disabled" (click)="onNo()">
            <i class="pi pi-check-circle" aria-hidden="true"></i> Proceed with selected guests
          </button>
        }
      </div>
    </div>
  }

  <!-- ── Step: Enter email ── -->
  @if (step() === 'enter-email') {
    <div class="guest-wizard__email-entry">
      <input type="email" class="guest-wizard__email-input"
        placeholder="Enter email address…"
        [value]="emailInput()"
        (input)="onEmailInput($event)"
        (keydown)="onEmailKeydown($event)"
        [disabled]="disabled"
        aria-label="Enter guest email" />
      @if (emailError()) {
        <p class="guest-wizard__email-error">{{ emailError() }}</p>
      }
      <div class="guest-wizard__options">
        <button type="button" class="guest-wizard__btn guest-wizard__btn--yes"
          [disabled]="disabled || !emailInput().trim()" (click)="onEmailConfirm()">
          <i class="pi pi-plus" aria-hidden="true"></i> Add
        </button>
        <button type="button" class="guest-wizard__back" [disabled]="disabled" (click)="onBackToMethod()">
          <i class="pi pi-arrow-left" aria-hidden="true"></i> Back
        </button>
      </div>
      @if (addedGuests().length > 0) {
        <button type="button" class="guest-wizard__btn guest-wizard__btn--no" [disabled]="disabled" (click)="onNo()">
          <i class="pi pi-check-circle" aria-hidden="true"></i> Proceed with selected guests
        </button>
      }
    </div>
  }

</div>
